<template>
  <div class="form-container">
    <!-- 页面标题 -->
    <div class="page-title">
      <h2>学校信息采集表</h2>
      <p>请完整填写以下信息，带<span class="required-mark">*</span>为必填项</p>
    </div>
    
    <!-- 修改密码按钮 -->
<!--    <div class="password-section">
      <el-button 
        type="primary" 
        @click="openPasswordDialog" 
        class="password-btn"
        size="medium"
      >
        <i class="el-icon-lock"></i> 修改密码
      </el-button>
    </div> -->
    
    <!-- 选择记录按钮 -->
    <div class="select-record-section">
      <el-button 
        type="primary" 
        @click="openRecordDialog" 
        class="select-record-btn"
        size="medium"
      >
        <i class="el-icon-document-copy"></i> K12商机完善
      </el-button>
	  <el-button
	    type="primary" 
	    @click="openPasswordDialog" 
	    class="password-btn"
	    size="medium"
	  >
	    <i class="el-icon-lock"></i> 修改密码
	  </el-button>
    </div>
    
    <!-- 记录选择对话框 -->
    <el-dialog
      title="K12商机完善（点击选择）"
      :visible.sync="recordDialogVisible"
      width="80%"
	  height="45%"
      top="5vh"
      :close-on-click-modal="false"
    >
      <div class="record-selector-container">
        <!-- 搜索框 -->
        <el-input
          v-model="searchKeyword"
          placeholder="搜索学校名称或所属区域"
          clearable
          class="search-input"
          size="medium"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
        
        <!-- 记录列表 -->
        <el-table
          :data="filteredRecords"
          v-loading="loadingRecords"
          stripe
          style="width: 100%"
          height="500px"
          @row-click="handleRecordSelect"
          highlight-current-row
        >
          <el-table-column prop="schoolName" label="学校名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="region" label="所属区域" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ (scope.row.region || []).join(' - ') }}
            </template>
          </el-table-column>
          <el-table-column prop="schoolType" label="学校类型" min-width="120"></el-table-column>
          <el-table-column prop="schoolNature" label="办学性质" min-width="120"></el-table-column>
          <el-table-column prop="contactName" label="联系人" min-width="100"></el-table-column>
          <el-table-column prop="contactPhone" label="联系电话" min-width="120"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="150" sortable>
            <template slot-scope="scope">
              {{ formatDate(scope.row.createTime) }}
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :total="schoolRecords.length"
            :page-size.sync="pageSize"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRecordSelect" :disabled="!selectedRecord">确认选择</el-button>
      </span>
    </el-dialog>

    <el-card class="form-card">
      <el-form
        ref="fullForm"
        :model="formData"
        :rules="formRules"
        :label-width="isMobile ? '90px' : '140px'"
        class="form-content"
      >
        <!-- 第一部分：学校基础信息 -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon school-icon"></div>
            <h3 class="section-title">学校基础信息</h3>
          </div>

          <!-- 学校名称 -->
          <el-form-item label="学校名称" prop="schoolName">
            <el-input
              v-model="formData.schoolName"
              placeholder="请输入学校名称"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 所属区域（修改为三个下拉框） -->
          <el-form-item label="所属区域" prop="region">
            <div class="region-select-group">
              <!-- 省份选择 -->
              <el-select
                v-model="provinceValue"
                placeholder="请选择省份"
                class="form-input region-select"
                size="medium"
                @change="handleProvinceChange"
				  :disabled="formData.schoolId>0"
                clearable
              >
                <el-option
                  v-for="province in regionOptions"
                  :key="province.value"
                  :label="province.label"
                  :value="province.value"
				    :disabled="formData.schoolId>0"
                ></el-option>
              </el-select>

              <!-- 城市选择 -->
              <el-select
                v-model="cityValue"
                placeholder="请选择城市"
                class="form-input region-select"
                size="medium"
                @change="handleCityChange"
                :disabled="!provinceValue"
                clearable
              >
                <el-option
                  v-for="city in cityOptions"
                  :key="city.value"
                  :label="city.label"
                  :value="city.value"
                ></el-option>
              </el-select>

              <!-- 区县选择 -->
              <el-select
                v-model="areaValue"
                placeholder="请选择区县"
                class="form-input region-select"
                size="medium"
                @change="handleAreaChange"
                :disabled="!cityValue"
                clearable
              >
                <el-option
                  v-for="area in areaOptions"
                  :key="area.value"
                  :label="area.label"
                  :value="area.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>

          <!-- 详细地址 -->
          <el-form-item label="详细地址" prop="address">
            <el-input
              v-model="formData.address"
              placeholder="请输入详细地址"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 学校类型 -->
          <el-form-item label="学校类型" prop="schoolType">
            <el-select
              v-model="formData.schoolType"
              placeholder="请选择学校类型"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            >
              <el-option label="小学" value="小学"></el-option>
              <el-option label="初中" value="初中"></el-option>
              <el-option label="高中" value="高中"></el-option>
              <el-option label="九年一贯制" value="九年一贯制"></el-option>
              <el-option label="十二年一贯制" value="十二年一贯制"></el-option>
              <el-option label="完全中学" value="完全中学"></el-option>
              <el-option label="中职" value="中职"></el-option>
            </el-select>
          </el-form-item>

          <!-- 办学性质 -->
          <el-form-item label="办学性质" prop="schoolNature">
            <el-select
              v-model="formData.schoolNature"
              placeholder="请选择办学性质"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            >
              <el-option label="公办" value="公办"></el-option>
              <el-option label="民办" value="民办"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>

          <!-- 在校学生人数 -->
          <el-form-item label="在校学生人数" prop="studentNum">
            <el-input-number
              v-model="formData.studentNum"
              :min="0"
              placeholder="请输入人数"
              class="form-input"
              size="medium"
              style="width: 100%"
			  :disabled="formData.schoolId>0"
            ></el-input-number>
          </el-form-item>

          <!-- 班级数量 -->
          <el-form-item label="班级数量" prop="classNum">
            <el-input-number
              v-model="formData.classNum"
              :min="0"
              placeholder="请输入班级数"
              class="form-input"
              size="medium"
              style="width: 100%"
			  :disabled="formData.schoolId>0"
            ></el-input-number>
          </el-form-item>

          <!-- 在职教师人数 -->
          <el-form-item label="在职教师人数">
            <el-input-number
              v-model="formData.teacherNum"
              :min="0"
              placeholder="请输入人数"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input-number>
          </el-form-item>
        </div>

        <!-- 第二部分：现状摸排与联系人 -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon user-icon"></div>
            <h3 class="section-title">现状摸排与联系人</h3>
          </div>

          <!-- 主要固话归属单位 -->
          <el-form-item label="主要固话归属单位" prop="phoneUnit">
            <el-input
              v-model="formData.phoneUnit"
              placeholder="请输入归属单位"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 当前网络供应商 -->
          <el-form-item label="当信息化网络供应商" prop="networkProvider">
            <el-select
              v-model="formData.networkProvider"
              placeholder="请选择供应商"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            >
              <el-option label="移动" value="移动"></el-option>
              <el-option label="电信" value="电信"></el-option>
              <el-option label="广电" value="广电"></el-option>
              <el-option label="其他" value="其他"></el-option>
              <el-option label="未知" value="未知"></el-option>
            </el-select>
          </el-form-item>

          <!-- 现有带宽/年费 -->
          <el-form-item label="现有带宽/年费">
            <el-input
              v-model="formData.bandwidth"
              placeholder="如：电信500M，年费约3万元"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 信息化系统现状 -->
          <el-form-item label="信息化系统现状">
            <el-select
              v-model="formData.infoSystem"
              placeholder="请选择系统（可多选）"
              multiple
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            >
              <el-option label="校园Wi-Fi" value="校园Wi-Fi"></el-option>
              <el-option label="监控安防" value="监控安防"></el-option>
              <el-option label="广播系统" value="广播系统"></el-option>
              <el-option label="多媒体教室" value="多媒体教室"></el-option>
              <el-option label="校务管理平台" value="校务管理平台"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>

          <!-- 关键痛点描述 -->
          <el-form-item label="关键痛点描述">
            <el-input
              v-model="formData.painPoint"
              type="textarea"
              :rows="3"
              placeholder="请输入痛点描述"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 关键联系人姓名 -->
          <el-form-item label="关键联系人姓名">
            <el-input
              v-model="formData.contactName"
              placeholder="请输入联系人姓名"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 联系人职务 -->
          <el-form-item label="联系人职务">
            <el-input
              v-model="formData.contactJob"
              placeholder="请输入职务"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>

          <!-- 联系人电话 -->
          <el-form-item label="联系人电话">
            <el-input
              v-model="formData.contactPhone"
              placeholder="请输入联系电话"
              class="form-input"
              size="medium"
			  :disabled="formData.schoolId>0"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 第三部分：进度管理（新增） -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon progress-icon"></div>
            <h3 class="section-title">进度管理</h3>
            <div class="section-actions">
              <el-button
                type="primary"
                size="small"
                @click="addProgressItem"
                class="add-progress-btn"
              >
                新增进度
              </el-button>
            </div>
          </div>

          <!-- 进度记录列表 -->
          <div class="progress-list">
            <div
              v-for="(progress, index) in formData.progressList"
              :key="index"
              class="progress-item"
            >
              <div class="progress-header">
                <span class="progress-title">进度记录 {{ index + 1 }}</span>
                <div class="progress-actions">
                  <el-button
                    v-if="formData.progressList.length > 1"
                    type="danger"
                    size="small"
                    plain
                    @click="removeProgressItem(index,progress)"
                    class="remove-progress-btn"
                  >
                    删除
                  </el-button>
                </div>
              </div>

              <div class="progress-content">
                <!-- 进度类型 -->
                <el-form-item
                  label="进度类型"
                  :prop="`progressList[${index}].type`"
                  :rules="[{ required: true, message: '请选择进度类型', trigger: 'change' }]"
                >
                  <el-select
                    v-model="progress.type"
                    placeholder="请选择进度类型"
                    class="form-input"
                    size="medium"
                  >
                    <el-option label="需求沟通" value="需求沟通"></el-option>
                    <el-option label="方案设计" value="方案设计"></el-option>
                    <el-option label="技术评估" value="技术评估"></el-option>
                    <el-option label="商务谈判" value="商务谈判"></el-option>
                    <el-option label="合同签订" value="合同签订"></el-option>
                    <el-option label="实施部署" value="实施部署"></el-option>
                    <el-option label="验收交付" value="验收交付"></el-option>
                    <el-option label="售后支持" value="售后支持"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 进度时间 -->
                <el-form-item
                  label="拜访时间"
                  :prop="`progressList[${index}].date`"
                  :rules="[{ required: true, message: '请选择拜访时间', trigger: 'change' }]"
                >
                  <el-date-picker
                    v-model="progress.date"
                    type="date"
                    placeholder="选择日期"
                    class="form-input"
                    size="medium"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>

                <!-- 客户经理 -->
                <el-form-item label="客户经理">
                  <el-input
                    v-model="progress.customerManager"  
                    placeholder="请输入客户经理姓名"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <br>
                <el-form-item label="联通公司领导">
                  <el-input
                    v-model="progress.unicomLeader"  
                    placeholder="请输入联通公司领导"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联通公司领导职务">
                  <el-input
                    v-model="progress.unicomLeaderPosition" 
                    placeholder="请输入职务"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联通公司领导电话">
                  <el-input
                    v-model="progress.unicomLeaderPhone" 
                    placeholder="请输入电话"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>

                <br>
                <el-form-item label="拜访校方人员">
                  <el-input
                    v-model="progress.schoolVisitor" 
                    placeholder="请输入拜访校方人员"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="校方人员职务">
                  <el-input
                    v-model="progress.schoolVisitorPosition"  
                    placeholder="请输入职务"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>
                <el-form-item label="校方人员电话">
                  <el-input
                    v-model="progress.schoolVisitorPhone"  
                    placeholder="请输入电话"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>

                <!-- 进度描述 -->
                <el-form-item
                  label="沟通内容"
                  :prop="`progressList[${index}].description`"
                  :rules="[{ required: true, message: '请输入进沟通内容', trigger: 'blur' }]"
                >
                  <el-input
                    v-model="progress.description"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入详细的沟通内容"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>

                <!-- 完成状态 -->
      <!--          <el-form-item label="完成状态">
                  <el-radio-group v-model="progress.status">
                    <el-radio label="进行中">进行中</el-radio>
                    <el-radio label="已完成">已完成</el-radio>
                    <el-radio label="待处理">待处理</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <!-- 新增：图片上传 -->
                <el-form-item label="拜访图片">
                  <div class="image-upload-wrapper">
                    <!-- 文件上传组件 -->
                    <el-upload
                      :action="uploadUrl"
                      :headers="uploadHeaders"
                      :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, index)"
                      :on-error="handleUploadError"
                      :on-remove="(file, fileList) => handleUploadRemove(file, fileList, index)"
                      :before-upload="beforeUpload"
                      :file-list="progress.imageList || []"
                      :limit="5"
                      list-type="picture-card"
                      :class="{ 'upload-disabled': uploadLoading }"
                      accept=".jpg,.jpeg,.png,.gif"
                    >
                      <i class="el-icon-plus"></i>
                      <!-- <div class="el-upload__tip" slot="tip">
                         支持JPG、PNG、GIF格式，单张不超过5MB，最多5张
                       </div> -->
                    </el-upload>

                    <!-- 上传loading状态 -->
                    <div v-if="uploadLoading" class="upload-loading">
                      <el-progress
                        type="circle"
                        :percentage="uploadProgress"
                        :width="80"
                        :stroke-width="4"
                        status="success"
                      ></el-progress>
                      <p>上传中...</p>
                    </div>

                    <!-- 图片预览模态框 -->
                    <el-dialog
                      :visible.sync="imagePreviewVisible"
                      title="图片预览"
                      width="80%"
                      top="5vh"
                      @close="currentPreviewImage = ''"
                    >
                      <div class="image-preview-container">
                        <img :src="currentPreviewImage" alt="预览图片" class="preview-image" />
                      </div>
                      <span slot="footer" class="dialog-footer">
                        <el-button @click="imagePreviewVisible = false">关闭</el-button>
                        <el-button type="primary" @click="downloadImage(currentPreviewImage)">
                          下载图片
                        </el-button>
                      </span>
                    </el-dialog>
                  </div>

                  <!-- 图片缩略图展示 -->
                  <div v-if="progress.imageList && progress.imageList.length > 0" class="image-thumbnail-list">
                    <div class="thumbnail-header">
                      <span class="thumbnail-title">已上传图片 ({{ progress.imageList.length }}/1)</span>
                      <el-button
                        type="text"
                        size="mini"
                        @click="clearAllImages(index)"
                        v-if="progress.imageList.length > 0"
                      >
                        清空全部
                      </el-button>
                    </div>
                    <div class="thumbnail-container">
                      <div
                        v-for="(image, imgIndex) in progress.imageList"
                        :key="imgIndex"
                        class="thumbnail-item"
                      >
                        <div class="thumbnail-content">
                          <img
                            :src="image.url"
                            :alt="`进度图片-${index + 1}-${imgIndex + 1}`"
                            class="thumbnail-image"
                            @click="previewImage(image.url)"
                          />
                          <div class="thumbnail-actions">
                            <el-button
                              type="text"
                              size="mini"
                              icon="el-icon-view"
                              @click="previewImage(image.url)"
                              title="预览"
                            ></el-button>
                            <el-button
                              type="text"
                              size="mini"
                              icon="el-icon-delete"
                              @click="removeImage(index, imgIndex)"
                              title="删除"
                            ></el-button>
                          </div>
                         <!-- <div class="thumbnail-info">
                            <span class="thumbnail-name">{{ image.name }}</span>
                            <span class="thumbnail-size">{{ formatFileSize(image.size) }}</span>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <!-- 第四部分：商机转化记录（改为列表形式） -->
        <div class="form-section">
          <div class="section-header">
            <div class="section-icon chart-icon"></div>
            <h3 class="section-title">商机记录</h3>
            <div class="section-actions">
              <el-button
                type="primary"
                size="small"
                @click="addBusinessRecord"
                class="add-record-btn"
              >
                新增记录
              </el-button>
            </div>
          </div>

          <!-- 商机记录列表 -->
          <div class="business-records">
            <div
              v-for="(record, index) in formData.businessRecords"
              :key="index"
              class="record-item"
            >
              <div class="record-header">
                <span class="record-title">商机记录 {{ index + 1 }}</span>
                <div class="record-actions">
                  <el-button
                    v-if="formData.businessRecords.length > 1"
                    type="danger"
                    size="small"
                    plain
                    @click="removeBusinessRecord(index,record)"
                    class="remove-record-btn"
                  >
                    删除
                  </el-button>
                </div>
              </div>

              <div class="record-content">
                <!-- 商机状态 -->
                <el-form-item
                  label="商机状态"
                  :prop="`businessRecords[${index}].businessStatus`"
                  :rules="[{ required: true, message: '请选择商机状态', trigger: 'change' }]"
                >
                  <el-select
                    v-model="record.businessStatus"
                    placeholder="请选择商机状态"
                    class="form-input"
                    size="medium"
                  >
                    <el-option label="意向初判" value="意向初判"></el-option>
                    <el-option label="需求确认" value="需求确认"></el-option>
                    <el-option label="方案提交" value="方案提交"></el-option>
                    <el-option label="商务谈判" value="商务谈判"></el-option>
                    <el-option label="项目建设" value="项目建设"></el-option>
                    <el-option label="项目交付" value="项目交付"></el-option>
                    <el-option label="已签约" value="已签约"></el-option>
                    <el-option label="已流失" value="已流失"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 智慧校园意向 -->
                <el-form-item
                  label="智慧校园意向"
                  :prop="`businessRecords[${index}].campusIntention`"
                  :rules="[{ required: true, message: '请选择智慧校园意向', trigger: 'change' }]"
                >
                  <el-select
                    v-model="record.campusIntention"
                    placeholder="请选择意向类型"
                    class="form-input"
                    size="medium"
                  >
                    <el-option label="基础圈校（电子学生证/插卡电话/视频电话）" value="基础圈校（电子学生证/插卡电话/视频电话）"></el-option>
                    <el-option label="智慧圈校" value="智慧圈校"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 预计签约时间 -->
                <el-form-item label="预计签约时间">
                  <el-date-picker
                    v-model="record.signTime"
                    type="date"
                    placeholder="选择日期"
                    class="form-input"
                    size="medium"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>

                <!-- 竞争对手 -->
                <el-form-item label="竞争对手">
                  <el-input
                    v-model="record.competitor"
                    placeholder="请输入竞争对手"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>

                <!-- 下次跟进时间 -->
                <el-form-item label="下次跟进时间">
                  <el-date-picker
                    v-model="record.followTime"
                    type="date"
                    placeholder="选择日期"
                    class="form-input"
                    size="medium"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>

                <!-- 用户转化时间 -->
                <el-form-item
                  label="用户转化时间"
                  :prop="`businessRecords[${index}].convertTime`"
                  :rules="[{ required: true, message: '请选择转化时间', trigger: 'change' }]"
                >
                  <el-date-picker
                    v-model="record.convertTime"
                    type="date"
                    placeholder="选择日期"
                    class="form-input"
                    size="medium"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>

                <!-- 用户转化数量 -->
                <el-form-item
                  label="用户转化数量"
                  :prop="`businessRecords[${index}].convertNum`"
                  :rules="[{ required: true, message: '请输入转化数量', trigger: 'blur' }]"
                >
                  <el-input-number
                    v-model="record.convertNum"
                    :min="0"
                    placeholder="请输入数量"
                    class="form-input"
                    size="medium"
                    style="width: 100%"
                  ></el-input-number>
                </el-form-item>

                <!-- 跟进记录 -->
                <el-form-item
                  label="跟进记录"
                  :prop="`businessRecords[${index}].followRecord`"
                  :rules="[{ required: true, message: '请填写跟进记录', trigger: 'blur' }]"
                >
                  <el-input
                    v-model="record.followRecord"
                    type="textarea"
                    :rows="3"
                    placeholder="记录人、时间、内容摘要、下一步计划"
                    class="form-input"
                    size="medium"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <!-- 提交按钮区 -->
        <div class="btn-wrapper">
          <el-button
            type="default"
            @click="resetForm"
            class="reset-btn"
            size="medium"
            style="width: 45%; margin-right: 10px"
          >
            重置表单
          </el-button>
          <el-button
            type="primary"
            @click="submitForm"
            class="submit-btn"
            size="medium"
            :loading="submitLoading"
            style="width: 45%"
          >
            提交表单
          </el-button>
		  
        </div>
      </el-form>
    </el-card>
    
    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px"
        class="password-form"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请确认新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="passwordLoading">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import provinceData from '../api/chengshi'

export default {
  name: "FormPage",
  data() {
    // 默认的商机记录
    const defaultBusinessRecord = {
      businessStatus: "",
      campusIntention: "",
      signTime: "",
      competitor: "",
      followTime: "",
      convertTime: "",
      convertNum: null,
      followRecord: "",
    };

    // 默认的进度记录（修复：拆分所有复用字段为独立字段）
    const defaultProgressRecord = {
      type: "",
      date: "",
      customerManager: "",       // 客户经理
      unicomLeader: "",          // 联通公司领导
      unicomLeaderPosition: "",  // 联通公司领导职务
      unicomLeaderPhone: "",     // 联通公司领导电话
      schoolVisitor: "",         // 拜访校方人员
      schoolVisitorPosition: "", // 校方人员职务
      schoolVisitorPhone: "",    // 校方人员电话
      description: "",
      status: "进行中",
      imageList: [], // 新增：图片列表
    };

    return {
      // 新增：图片上传相关数据
      uploadUrl: 'http://sx.lio8.com.cn/api/common/upload', // 替换为你的实际上传接口
      uploadHeaders: {
        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
      },
      uploadLoading: false,
      uploadProgress: 0,
      imagePreviewVisible: false,
      currentPreviewImage: '',
      // 提交加载状态
      submitLoading: false,
      // 是否为移动端
      isMobile: false,
      // 标准格式的省市区三级联动数据（value/label/children）
      regionOptions: [],
      // 城市下拉框选项
      cityOptions: [],
      // 区县下拉框选项
      areaOptions: [],
      // 省份选中值
      provinceValue: '',
      // 城市选中值
      cityValue: '',
      // 区县选中值
      areaValue: '',
      // 记录选择相关数据
      recordDialogVisible: true, // 记录选择对话框可见性
      schoolRecords: [], // 所有学校记录列表
      filteredRecords: [], // 过滤后的记录列表
      selectedRecord: null, // 当前选中的记录
      searchKeyword: '', // 搜索关键词
      loadingRecords: false, // 加载记录的loading状态
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      // 修改密码相关数据
      passwordDialogVisible: false, // 修改密码对话框可见性
      passwordLoading: false, // 修改密码加载状态
      passwordForm: {
        oldPassword: '', // 原密码
        newPassword: '', // 新密码
        confirmPassword: '' // 确认密码
      },
      // 修改密码验证规则
      passwordRules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "新密码长度至少为6位", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      // 表单数据
      formData: {
        schoolId: '',
        schoolName: "",
        region: [], // 存储格式：["北京", "北京市", "东城区"]
        address: "",
        schoolType: "",
        schoolNature: "",
        studentNum: null,
        classNum: null,
        teacherNum: null,
        phoneUnit: "",
        networkProvider: "",
        bandwidth: "",
        infoSystem: [],
        painPoint: "",
        contactName: "",
        contactJob: "",
        contactPhone: "",
        // 商机转化记录列表
        businessRecords: [{ ...defaultBusinessRecord }],
        // 进度管理记录列表
        progressList: [{ ...defaultProgressRecord }],
      },
      // 表单验证规则
      formRules: {
        schoolName: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
        region: [{ 
          required: true, 
          message: "请选择完整的省/市/区县", 
          trigger: "change",
          validator: (rule, value, callback) => {
            if (value && value.length === 3) {
              callback();
            } else {
              callback(new Error('请选择完整的省/市/区县'));
            }
          }
        }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        schoolType: [{ required: true, message: "请选择学校类型", trigger: "change" }],
        schoolNature: [{ required: true, message: "请选择办学性质", trigger: "change" }],
        studentNum: [{ required: true, message: "请输入学生人数", trigger: "blur" }],
        classNum: [{ required: true, message: "请输入班级数量", trigger: "blur" }],
        phoneUnit: [{ required: true, message: "请输入固话归属单位", trigger: "blur" }],
        networkProvider: [{ required: true, message: "请选择网络供应商", trigger: "change" }],
        // 商机记录的整体验证在数组第一个元素上
        'businessRecords[0].businessStatus': [{ required: true, message: "请选择商机状态", trigger: "change" }],
        'businessRecords[0].campusIntention': [{ required: true, message: "请选择智慧校园意向", trigger: "change" }],
        'businessRecords[0].followRecord': [{ required: true, message: "请填写跟进记录", trigger: "blur" }],
        'businessRecords[0].convertTime': [{ required: true, message: "请选择转化时间", trigger: "change" }],
        'businessRecords[0].convertNum': [{ required: true, message: "请输入转化数量", trigger: "blur" }],
        // 进度记录的整体验证
        'progressList[0].type': [{ required: true, message: "请选择进度类型", trigger: "change" }],
        'progressList[0].date': [{ required: true, message: "请选择进度时间", trigger: "change" }],
        'progressList[0].description': [{ required: true, message: "请输入进度描述", trigger: "blur" }],
      },
    };
  },
  created() {
    // 转换原始数据为标准value/label/children格式
    this.regionOptions = this.transformToStandardFormat(provinceData.data);
    // 初始化判断设备类型
    this.checkMobile();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkMobile);
	
	//列表获取信息
	// this.listDataInfo();
	this.listSchoolInfoByUserId();
  },
  destroyed() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
	   async listSchoolInfoByUserId(){
		   //查询填写过的学校记录信息
		   this.loadingRecords = true;
		   try {
			   const response = await this.$http.get('/student/schoolInfo/api/listSchoolByUserId', {});
			   console.log("填写过的记录：",response);
			   if (response.data && response.data.code === 200) {
				   // 将后端返回的province、city、district合并为region数组
				   this.schoolRecords = (response.data.data || []).map(record => ({
					   ...record,
					   region: [record.province, record.city, record.district].filter(Boolean)
				   }));
				   this.filteredRecords = [...this.schoolRecords];
			   } else {
				   this.$message.warning(response.data.msg || '获取记录失败');
				   this.schoolRecords = [];
				   this.filteredRecords = [];
				   localStorage.removeItem('isAuthenticated')
				   Message.error('登录已过期，请重新登录')
				   window.location.href = 'http://sx.lio8.com.cn/' // 跳回登录页
			   }
		   } catch (error) {
			   console.error("获取记录失败：", error);
			   this.$message.error('获取记录失败，请检查网络连接');
			   this.schoolRecords = [];
			   this.filteredRecords = [];
		   } finally {
			   this.loadingRecords = false;
		   }
	   },
	 async listDataInfo(){
		  //查询信息
		  const response = await this.$http.get('/student/schoolInfo/api/select', {});
		 
		  if (response.data.code === 200) {
		     console.log("结果返回值：",response.data);
			  var responseData = response.data.data;
			  
			  // 1. 基础字段直接赋值
			    this.formData.schoolId = responseData.schoolId || "";
			  this.formData.schoolName = responseData.schoolName || "";
			  this.formData.address = responseData.detailAddress || "";
			  this.formData.schoolType = responseData.schoolType || "";
			  this.formData.schoolNature = responseData.runType || "";
			  this.formData.studentNum = responseData.studentCount || "";
			  this.formData.classNum = responseData.classCount || "";
			  this.formData.teacherNum = responseData.teacherCount || "";
			  this.formData.phoneUnit = responseData.mainClientUnit || "";
			  this.formData.networkProvider = responseData.networkSupplier || "";
			  this.formData.bandwidth = responseData.bandwidthCost || "";
			  this.formData.painPoint = responseData.painPoint || "";
			  this.formData.contactName = responseData.contactName || "";
			  this.formData.contactJob = responseData.contactPosition || "";
			  this.formData.contactPhone = responseData.contactPhone || "";
			
			
			  // 2. 省市区数组特殊处理
			  this.formData.region = [
			    responseData.province || "",
			    responseData.city || "",
			    responseData.district || ""
			  ];
			  this.provinceValue = this.formData.region[0];
			  this.cityValue = this.formData.region[1];
			  this.areaValue = this.formData.region[2];
			  
			    // 3. JSON字符串解析（如果需要在前端展示/编辑）
			    // 注意：需要做异常处理，避免JSON格式错误导致页面报错
			    try {
			      // 解析业务记录
			      if (responseData.businessRecordList) {
			        this.formData.businessRecords = responseData.businessRecordList;
			      }
			      // 解析进度记录
			      if (responseData.progressRecordList) {
			        this.formData.progressList = this.convertProgressData(responseData.progressRecordList);
			      }
			      // 解析信息化系统（字符串转数组，根据你的存储格式调整）
			      if (responseData.informatizationSystem) {
			        this.formData.infoSystem = [...responseData.informatizationSystem.split(",")];
			      }
				  console.log("整合好的信息：",this.formData);
			    } catch (e) {
			      console.error("数据解析失败：", e);
			      // 解析失败时给默认值，避免页面崩溃
			    }
		  } else {
		    this.$message.warning(response.data.msg || '提交失败');
			localStorage.removeItem('isAuthenticated')
			Message.error('登录已过期，请重新登录')
			window.location.href = 'http://sx.lio8.com.cn/' // 跳回登录页
		  }
	  },
	  // 核心：后端数据转前端表单数据
	   convertProgressData(backendProgressList) {
	    if (!backendProgressList || !Array.isArray(backendProgressList)) {
	      // 无数据时返回至少一个空项，保证前端能渲染新增入口
	      return [{
	        type: "",
	        date: "",
	        customerManager: "",
	        unicomLeader: "",
	        unicomLeaderPosition: "",
	        unicomLeaderPhone: "",
	        schoolVisitor: "",
	        schoolVisitorPosition: "",
	        schoolVisitorPhone: "",
	        description: "",
	        status: "进行中", // 默认状态
	        imageList: [] // 默认空图片列表
	      }];
	    }
	  
	    // 遍历后端数据，转换为前端格式
	    return backendProgressList.map(item => {
	      // 处理日期格式：后端Date转前端yyyy-MM-dd字符串
	      let dateStr = "";
	      if (item.visitDate) {
	        // 兼容后端返回的Date字符串（如 "2026-01-10T00:00:00.000+00:00" 或 "2026-01-10"）
	        const date = new Date(item.visitDate);
	        if (!isNaN(date.getTime())) {
	          dateStr = date.toISOString().split('T')[0]; // 转为 yyyy-MM-dd
	        }
	      }
	  
	      // 处理图片列表：后端imageList转前端上传组件格式
	      let frontImageList = [];
	      // if (item.imageList && Array.isArray(item.imageList)) {
	      //   frontImageList = item.imageList.map(img => {
	      //     return {
	      //       // 前端上传组件需要的字段映射
	      //       name: img.imageName || "",
	      //       url: img.imageUrl || "",
	      //       size: img.imageSize ? Number(img.imageSize) : 0, // 转为数字
	      //       format: img.imageFormat || "",
	      //       // 补充上传组件默认字段（根据element-ui upload组件要求）
	      //       uid: img.imageUrl || new Date().getTime() + Math.random(),
	      //       status: "success" // 标记为已上传成功
	      //     };
	      //   });
	      // }
		  
		  frontImageList = [{
			  name:"image1",
			  url:item.visitImage,
			 uid: item.visitImage || new Date().getTime() + Math.random(),
			    status: "success" // 标记为已上传成功
		  }]
		console.log("拜访时间：",dateStr);
	      // 字段映射核心逻辑
	      return {
	        id: item.id || "", // 保留主键，便于后续编辑/删除
	        type: item.progressType || "", // 进度类型
	        date: dateStr, // 拜访时间
	        customerManager: item.customerManager || "", // 客户经理
	        unicomLeader: item.unicomLeader || "", // 联通公司领导
	        unicomLeaderPosition: item.unicomLeaderPosition || "", // 联通领导职务
	        unicomLeaderPhone: item.unicomLeaderPhone || "", // 联通领导电话
	        schoolVisitor: item.schoolVisitor || "", // 拜访校方人员
	        schoolVisitorPosition: item.schoolVisitorPosition || "", // 校方人员职务
	        schoolVisitorPhone: item.schoolVisitorPhone || "", // 校方人员电话
	        description: item.communicationContent || "", // 沟通内容
	        status: item.status || "进行中", // 完成状态
	        visitImage: item.visitImage || "", // 图片路径（备用）
	        imageList: frontImageList // 图片列表
	      };
	    });
	  },
    transformToStandardFormat(rawData) {
      return rawData.map(province => {
        const provinceItem = {
          value: province.name,
          label: province.name,
          children: []
        };

        province.city.forEach(city => {
          const cityItem = {
            value: city.name,
            label: city.name,
            children: []
          };

          city.area.forEach(area => {
            cityItem.children.push({
              value: area,
              label: area
            });
          });

          provinceItem.children.push(cityItem);
        });

        return provinceItem;
      });
    },
    // 判断是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    // 省份选择变化
    handleProvinceChange(val) {
      // 清空城市和区县
      this.cityValue = '';
      this.areaValue = '';
      this.cityOptions = [];
      this.areaOptions = [];
      
      if (val) {
        // 查找选中省份的城市列表
        const province = this.regionOptions.find(item => item.value === val);
        if (province && province.children) {
          this.cityOptions = province.children;
        }
      }
      
      // 更新region数据
      this.updateRegionData();
    },
	
    // 城市选择变化
    handleCityChange(val) {
      // 清空区县
      this.areaValue = '';
      this.areaOptions = [];
      
      if (val && this.provinceValue) {
        // 查找选中省份
        const province = this.regionOptions.find(item => item.value === this.provinceValue);
        if (province) {
          // 查找选中城市的区县列表
          const city = province.children.find(item => item.value === val);
          if (city && city.children) {
            this.areaOptions = city.children;
          }
        }
      }
      
      // 更新region数据
      this.updateRegionData();
    },
    // 区县选择变化
    handleAreaChange(val) {
      // 更新region数据
      this.updateRegionData();
    },
    // 更新region数据
    updateRegionData() {
      this.formData.region = [this.provinceValue, this.cityValue, this.areaValue].filter(Boolean);
      // 手动触发验证
      this.$refs.fullForm.validateField('region');
    },
    // 新增商机记录
    addBusinessRecord() {
      const defaultRecord = {
        businessStatus: "",
        campusIntention: "",
        signTime: "",
        competitor: "",
        followTime: "",
        convertTime: "",
        convertNum: null,
        followRecord: "",
      };
      this.formData.businessRecords.push({ ...defaultRecord });
    },
    // 删除商机记录
    async removeBusinessRecord(index,obj) {
      if (this.formData.businessRecords.length > 1) {
        this.formData.businessRecords.splice(index, 1);
		
		//删除记录
		console.log("删除记录对象：",obj);
		var response = await this.$http.delete('/system/BusinessOpportunity/'+obj.id, {});
		console.log("删除结果",response);
      } else {
        this.$message.warning("至少需要保留一条商机记录");
      }
    },
    // 新增进度记录（修复：使用拆分后的默认字段）
    addProgressItem() {
      const defaultProgress = {
        type: "",
        date: "",
        customerManager: "",       // 客户经理
        unicomLeader: "",          // 联通公司领导
        unicomLeaderPosition: "",  // 联通公司领导职务
        unicomLeaderPhone: "",     // 联通公司领导电话
        schoolVisitor: "",         // 拜访校方人员
        schoolVisitorPosition: "", // 校方人员职务
        schoolVisitorPhone: "",    // 校方人员电话
        description: "",
        status: "进行中",
        imageList: [],
      };
      this.formData.progressList.push({ ...defaultProgress });
    },
    // 删除进度记录
    async removeProgressItem(index,obj) {
      if (this.formData.progressList.length > 1) {
        this.formData.progressList.splice(index, 1);
		//删除记录
		console.log("删除进度记录对象：",obj);
		var response = await this.$http.delete('/system/ProgressRecord/'+obj.id, {});
		console.log("删除结果",response);
      } else {
        this.$message.warning("至少需要保留一条进度记录");
      }
    },
    // 提交表单（修复：进度记录字段映射，匹配MySQL）
    async submitForm() {
		console.log("当前表单状态：",this.formData.schoolId);
      try {
        await this.$refs.fullForm.validate();
        this.submitLoading = true;
        
        // 准备提交数据
        const infoSystemStr = (this.formData.infoSystem || []).join(',');
        
        // 处理商机记录
        const businessRecords = this.formData.businessRecords.map(record => ({
			id:record.id,
          businessStatus: record.businessStatus,
          campusIntention: record.campusIntention,
          signTime: record.signTime,
          competitor: record.competitor,
          followTime: record.followTime,
          convertTime: record.convertTime,
          convertNum: record.convertNum,
          followRecord: record.followRecord,
        }));
        
        // 处理进度记录（修复：字段精准匹配MySQL表）
        const progressList = this.formData.progressList.map(progress => ({
			id:progress.id,
          progressType: progress.type,                // 对应MySQL: progress_type
          visitDate: progress.date,                   // 对应MySQL: visit_date
          customerManager: progress.customerManager,  // 对应MySQL: customer_manager
          unicomLeader: progress.unicomLeader,        // 对应MySQL: unicom_leader
          unicomLeaderPosition: progress.unicomLeaderPosition, // 对应MySQL: unicom_leader_position
          unicomLeaderPhone: progress.unicomLeaderPhone,       // 对应MySQL: unicom_leader_phone
          schoolVisitor: progress.schoolVisitor,               // 对应MySQL: school_visitor
          schoolVisitorPosition: progress.schoolVisitorPosition, // 对应MySQL: school_visitor_position
          schoolVisitorPhone: progress.schoolVisitorPhone,     // 对应MySQL: school_visitor_phone
          communicationContent: progress.description, // 对应MySQL: communication_content
          status: progress.status,                    // 对应MySQL: status
          // 图片列表单独处理（实际项目中先上传图片，再传图片ID/URL）
          imageList: progress.imageList.map(img => ({
            imageName: img.name,
            imageUrl: img.url,
            imageSize: img.size,
            imageFormat: img.name.split('.').pop()
          }))
        }));

        const formDatas = {
			schoolId:this.formData.schoolId,
          schoolName: this.formData.schoolName,
          province: this.formData.region[0],
          city: this.formData.region[1],
          district: this.formData.region[2],
          detailAddress: this.formData.address,
          schoolType: this.formData.schoolType,
          runType: this.formData.schoolNature,
          studentCount: this.formData.studentNum,
          classCount: this.formData.classNum,
          teacherCount: this.formData.teacherNum,
          mainClientUnit: this.formData.phoneUnit,
          networkSupplier: this.formData.networkProvider,
          bandwidthCost: this.formData.bandwidth,
          informatizationSystem: infoSystemStr,
          painPoint: this.formData.painPoint,
          contactName: this.formData.contactName,
          contactPosition: this.formData.contactJob,
          contactPhone: this.formData.contactPhone,
          businessRecords: JSON.stringify(businessRecords),
          progressList: JSON.stringify(progressList), // 进度记录字段已匹配MySQL
        };
 var  response;
		if(this.formData.schoolId > 0){
			//新增进度管理或者商机管理
			response = await this.$http.post('/student/schoolInfo/updateOther', formDatas);
		}else{
			 response = await this.$http.post('/student/schoolInfo/save', formDatas);
		}
        
        
        if (response.data.code === 200) {
          this.$message.success('提交成功！');
        } else {
          this.$message.warning(response.data.msg || '提交失败，请重新登录');
        }
      } catch (error) {
        if (error instanceof Error) {
          // 验证失败
          this.$message.error("表单填写不完整，请检查必填项！");
        } else {
          // 请求失败
          this.$message.error(error.response?.data?.msg || '服务器错误，请重新登录');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    // 重置表单（修复：重置进度记录为拆分后的默认字段）
    resetForm() {
      this.$refs.fullForm.resetFields();
      // 重置下拉框值
      this.provinceValue = '';
      this.cityValue = '';
      this.areaValue = '';
      this.cityOptions = [];
      this.areaOptions = [];
      
      // 重置表单数据到初始状态
      const defaultBusinessRecord = {
        businessStatus: "",
        campusIntention: "",
        signTime: "",
        competitor: "",
        followTime: "",
        convertTime: "",
        convertNum: null,
        followRecord: "",
      };
      
      const defaultProgressRecord = {
        type: "",
        date: "",
        customerManager: "",       // 客户经理
        unicomLeader: "",          // 联通公司领导
        unicomLeaderPosition: "",  // 联通公司领导职务
        unicomLeaderPhone: "",     // 联通公司领导电话
        schoolVisitor: "",         // 拜访校方人员
        schoolVisitorPosition: "", // 校方人员职务
        schoolVisitorPhone: "",    // 校方人员电话
        description: "",
        status: "进行中",
        imageList: [],
      };
      
      this.formData = {
        schoolName: "",
        region: [],
        address: "",
        schoolType: "",
        schoolNature: "",
        studentNum: null,
        classNum: null,
        teacherNum: null,
        phoneUnit: "",
        networkProvider: "",
        bandwidth: "",
        infoSystem: [],
        painPoint: "",
        contactName: "",
        contactJob: "",
        contactPhone: "",
        businessRecords: [{ ...defaultBusinessRecord }],
        progressList: [{ ...defaultProgressRecord }],
      };
      
      this.$message.info("表单已重置！");
    },
    // 以下为图片上传相关方法（补充实现，保证功能完整）
    beforeUpload(file) {
      // 限制文件大小5MB
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB!');
        return false;
      }
      // 限制文件类型
      const isImage = /\.(jpg|jpeg|png|gif)$/.test(file.name);
      if (!isImage) {
        this.$message.error('仅支持JPG、PNG、GIF格式图片!');
        return false;
      }
      this.uploadLoading = true;
      this.uploadProgress = 0;
      // 模拟上传进度
      this.uploadInterval = setInterval(() => {
        if (this.uploadProgress < 90) {
          this.uploadProgress += 10;
        }
      }, 200);
      return true;
    },
    handleUploadSuccess(response, file, fileList, index) {
		console.log("图片成功返回值：",response);
      clearInterval(this.uploadInterval);
      this.uploadLoading = false;
      this.uploadProgress = 100;
      // 假设接口返回图片URL
      const imageUrl = response.data?.url || file.url;
      this.formData.progressList[index].imageList = fileList.map(item => ({
        name: item.name,
        url: response.url,
        size: item.size
      }));
      this.$message.success('图片上传成功!');
    },
    handleUploadError() {
      clearInterval(this.uploadInterval);
      this.uploadLoading = false;
      this.uploadProgress = 0;
      this.$message.error('图片上传失败，请重试!');
    },
    handleUploadRemove(file, fileList, index) {
      this.formData.progressList[index].imageList = fileList.map(item => ({
        name: item.name,
        url: item.url,
        size: item.size
      }));
    },
    previewImage(url) {
      this.currentPreviewImage = url;
      this.imagePreviewVisible = true;
    },
    downloadImage(url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = `进度图片_${new Date().getTime()}`;
      link.click();
    },
    clearAllImages(index) {
      this.formData.progressList[index].imageList = [];
    },
    removeImage(progressIndex, imgIndex) {
      this.formData.progressList[progressIndex].imageList.splice(imgIndex, 1);
    },
    
    // 记录选择相关方法
    // 打开记录选择对话框
    openRecordDialog() {
      this.searchKeyword = '';
      this.selectedRecord = null;
      this.currentPage = 1;
      // 获取最新记录列表
      this.listSchoolInfoByUserId();
      // 打开对话框
      this.recordDialogVisible = true;
    },
    
    // 搜索记录
    handleSearch() {
      this.currentPage = 1;
      this.filterRecords();
    },
    
    // 过滤记录
    filterRecords() {
      if (!this.searchKeyword) {
        this.filteredRecords = [...this.schoolRecords];
        return;
      }
      
      const keyword = this.searchKeyword.toLowerCase();
      this.filteredRecords = this.schoolRecords.filter(record => {
        // 搜索学校名称或所属区域
        const schoolNameMatch = record.schoolName?.toLowerCase().includes(keyword);
        const regionMatch = (record.region || []).join('').toLowerCase().includes(keyword);
        return schoolNameMatch || regionMatch;
      });
    },
    
    // 处理记录选择
    handleRecordSelect(row) {
      this.selectedRecord = row;
    },
    
    // 确认选择记录
    async confirmRecordSelect() {
      if (!this.selectedRecord) return;
      
      try {
        // 调用listDataInfo方法加载选中记录的详细数据
        // 假设listDataInfo方法需要schoolId参数，这里需要修改或添加一个新方法
        // 这里我们先直接使用selectedRecord的数据填充表单
		console.log("当前选择了多少：",this.selectedRecord);
        this.loadRecordData(this.selectedRecord);
        this.recordDialogVisible = false;
        this.$message.success('记录选择成功！');
      } catch (error) {
        console.error('加载记录数据失败：', error);
        this.$message.error('加载记录数据失败，请重试');
      }
    },
    
    // 打开修改密码对话框
    openPasswordDialog() {
      // 重置密码表单
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      // 打开对话框
      this.passwordDialogVisible = true;
    },
    
    // 提交密码修改
    async submitPassword() {
      try {
        // 验证表单
        await this.$refs.passwordForm.validate();
        this.passwordLoading = true;
        
        // 准备提交数据
        const passwordData = {
          password: this.passwordForm.newPassword
        };
        
        // 调用修改密码接口
        const response = await this.$http.put('/system/user/resetPwd', passwordData);
        
        if (response.data.code === 200) {
          this.$message.success('密码修改成功！');
          this.passwordDialogVisible = false;
        } else {
          this.$message.warning(response.data.msg || '密码修改失败，请检查原密码是否正确');
        }
      } catch (error) {
        if (error instanceof Error) {
          // 验证失败
          this.$message.error("表单填写不完整，请检查必填项！");
        } else {
          // 请求失败
          // this.$message.error(error.response?.data?.msg || '服务器错误，请重新登录');
        }
      } finally {
        this.passwordLoading = false;
      }
    },
    
    // 加载记录数据到表单
    loadRecordData(record) {
      // 1. 基础字段直接赋值
      this.formData.schoolId = record.schoolId || '';
      this.formData.schoolName = record.schoolName || '';
      this.formData.address = record.detailAddress || '';
      this.formData.schoolType = record.schoolType || '';
      this.formData.schoolNature = record.runType || '';
      this.formData.studentNum = record.studentCount || null;
      this.formData.classNum = record.classCount || null;
      this.formData.teacherNum = record.teacherCount || null;
      this.formData.phoneUnit = record.mainClientUnit || '';
      this.formData.networkProvider = record.networkSupplier || '';
      this.formData.bandwidth = record.bandwidthCost || '';
      this.formData.painPoint = record.painPoint || '';
      this.formData.contactName = record.contactName || '';
      this.formData.contactJob = record.contactPosition || '';
      this.formData.contactPhone = record.contactPhone || '';
      
      // 2. 省市区数组特殊处理
      // 优先使用原始的province、city、district字段，确保数据准确性
      this.formData.region = [
        record.province || '',
        record.city || '',
        record.district || ''
      ];
      this.provinceValue = this.formData.region[0];
      this.cityValue = this.formData.region[1];
      this.areaValue = this.formData.region[2];
      
      // 确保region数组至少有3个元素，防止提交时出错
      // while (this.formData.region.length < 3) {
      //   this.formData.region.push('');
      // }
      
      // 3. 重新加载城市和区县选项
      // if (this.provinceValue) {
      //   this.handleProvinceChange(this.provinceValue);
      //   setTimeout(() => {
      //     if (this.cityValue) {
      //       this.handleCityChange(this.cityValue);
      //     }
      //   }, 100);
      // }
      
      // 4. 信息化系统（字符串转数组）
      if (record.informatizationSystem) {
        this.formData.infoSystem = [...record.informatizationSystem.split(",")];
      } else {
        this.formData.infoSystem = [];
      }
      
      // 5. 商机记录和进度记录需要额外请求获取详情
      // 这里假设record对象中已经包含了详细数据，否则需要额外请求
      try {
        if (record.businessRecordList) {
          this.formData.businessRecords = record.businessRecordList;
        } else {
          this.formData.businessRecords = [{ 
            businessStatus: "",
            campusIntention: "",
            signTime: "",
            competitor: "",
            followTime: "",
            convertTime: "",
            convertNum: null,
            followRecord: "",
          }];
        }
        
        if (record.progressRecordList) {
          this.formData.progressList = this.convertProgressData(record.progressRecordList);
        } else {
          this.formData.progressList = [{ 
            type: "",
            date: "",
            customerManager: "",       // 客户经理
            unicomLeader: "",          // 联通公司领导
            unicomLeaderPosition: "",  // 联通公司领导职务
            unicomLeaderPhone: "",     // 联通公司领导电话
            schoolVisitor: "",         // 拜访校方人员
            schoolVisitorPosition: "", // 校方人员职务
            schoolVisitorPhone: "",    // 校方人员电话
            description: "",
            status: "进行中",
            imageList: [],
          }];
        }
      } catch (e) {
        console.error("数据解析失败：", e);
      }
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    
    // 分页相关方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
  },
};
</script>

<style scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  touch-action: manipulation;
}

/* 修改密码按钮区域 */
.password-section {
  display: flex;
  margin-bottom: 20px;
  padding: 0 10px;
}
.password-btn {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.password-btn:hover {
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  transform: translateY(-1px);
}

/* 选择记录按钮区域 */
.select-record-section {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.select-record-btn {
  border-radius: 8px;
  background: linear-gradient(90deg, #409eff, #36cfc9);
  border: none;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  transition: all 0.3s ease;
}

.select-record-btn:hover {
  background: linear-gradient(90deg, #3390e7, #2ec4b6);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transform: translateY(-1px);
}

/* 记录选择对话框样式 */
.record-selector-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 800px;
}

.search-input {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 表格样式优化 */
.record-selector-container .el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.record-selector-container .el-table__header-wrapper {
  background: #f8fafc;
}

.record-selector-container .el-table__header-wrapper th {
  background: #f8fafc;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #e2e8f0;
}

.record-selector-container .el-table__body-wrapper {
  background: #ffffff;
}

.record-selector-container .el-table__body tr:hover {
  background-color: #f0f9ff;
}

.record-selector-container .el-table__body tr.current-row {
  background-color: #e0f2fe;
}

.record-selector-container .el-table--striped .el-table__body tr.el-table__row--striped {
  background-color: #fafafa;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding: 10px;
  background: #f8fafc;
  border-radius: 8px;
}

/* 对话框按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.dialog-footer .el-button {
  padding: 8px 30px;
  border-radius: 6px;
  font-weight: 500;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .record-selector-container .el-table {
    height: 400px;
  }
  
  .pagination-container {
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .dialog-footer {
    flex-direction: column;
  }
  
  .dialog-footer .el-button {
    width: 100%;
  }
}

/* 页面容器 */
.form-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #e4eaf5 100%);
  padding: 20px 10px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}

/* 页面标题 */
.page-title {
  text-align: center;
  margin-bottom: 20px;
  padding: 0 10px;
}
.page-title h2 {
  color: #1f2937;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}
.page-title p {
  color: #6b7280;
  font-size: 12px;
  line-height: 1.4;
}
.required-mark {
  color: #f56c6c;
  font-weight: bold;
}

/* 表单卡片 */
.form-card {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(149, 157, 165, 0.1);
  border-radius: 8px;
  border: none;
  overflow: hidden;
  background: #ffffff;
  padding: 0 !important;
}

/* 表单内容区 */
.form-content {
  padding: 20px 15px;
  width: 100%;
  box-sizing: border-box;
}

/* 表单分区块 */
.form-section {
  margin-bottom: 30px;
  width: 100%;
}

/* 区块头部 */
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  justify-content: space-between;
}
.section-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}
/* 模块图标配色 */
.school-icon { background-color: #409eff; }
.user-icon { background-color: #67c23a; }
.chart-icon { background-color: #e6a23c; }
.progress-icon { background-color: #9c27b0; }

.section-title {
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.section-actions {
  display: flex;
  gap: 10px;
}

/* 商机记录和进度记录容器 */
.business-records,
.progress-list {
  margin-top: 15px;
}

/* 记录项样式 */
.record-item,
.progress-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
}

.record-item:hover,
.progress-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 记录头部 */
.record-header,
.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.record-title,
.progress-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

/* 记录内容布局 */
.record-content,
.progress-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
}

/* 表单项通用样式 */
.el-form-item {
  margin-bottom: 15px;
  width: 100%;
}

/* 区域选择组样式 */
.region-select-group {
  display: flex;
  gap: 10px;
  width: 100%;
}
.region-select {
  flex: 1;
}

/* 输入框/选择器样式 */
.form-input {
  border-radius: 6px;
  transition: all 0.3s ease;
  background-color: #f9fafb;
  width: 100% !important;
  box-sizing: border-box;
}
.form-input:focus,
.form-input:hover {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  background-color: #ffffff;
}

/* 移动端输入框/选择器适配 */
.el-input, .el-select, .el-input-number, .el-date-picker, .el-cascader {
  width: 100% !important;
}
.el-input__inner, .el-select__input, .el-input-number__inner, .el-cascader__input {
  height: 40px;
  font-size: 14px;
  padding: 0 12px;
}
.el-textarea__inner {
  font-size: 14px;
  padding: 10px 12px;
}

/* 按钮容器 */
.btn-wrapper {
  margin-top: 15px;
  padding-top: 20px;
  border-top: 1px dashed #e8f4ff;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 按钮样式 */
.reset-btn, .submit-btn {
  padding: 10px 0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reset-btn {
  border-color: #d1d5db;
  color: #4b5563;
  background-color: #f9fafb;
}
.reset-btn:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}
.submit-btn {
  background: linear-gradient(90deg, #409eff, #36cfc9);
  border: none;
}
.submit-btn:hover {
  background: linear-gradient(90deg, #3390e7, #2ec4b6);
}

/* 新增/删除按钮样式 */
.add-record-btn,
.add-progress-btn,
.remove-record-btn,
.remove-progress-btn {
  font-size: 12px;
  padding: 5px 10px;
}

/* 大屏适配（≥768px） */
@media (min-width: 768px) {
  .form-container {
    padding: 40px 20px;
  }
  .page-title h2 {
    font-size: 24px;
  }
  .page-title p {
    font-size: 14px;
  }
  .form-content {
    padding: 40px 50px;
  }
  .form-section {
    margin-bottom: 45px;
  }
  .section-icon {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
  .section-title {
    font-size: 18px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .form-input {
    border-radius: 8px;
  }
  
  /* 记录内容网格布局 */
  .record-content {
    grid-template-columns: repeat(2, 1fr);
  }
  .progress-content {
    grid-template-columns: repeat(2, 1fr);
  }
  
  /* 某些表单项占两列 */
  .record-content .el-form-item:nth-last-child(-n+2),
  .progress-content .el-form-item:nth-last-child(-n+2) {
    grid-column: span 2;
  }
  
  .btn-wrapper {
    margin-top: 20px;
    padding-top: 25px;
  }
  .reset-btn, .submit-btn {
    padding: 12px 40px;
    font-size: 15px;
    height: auto;
    width: auto !important;
  }
}

/* 移动端区域选择组适配 */
@media (max-width: 767px) {
  .region-select-group {
    flex-direction: column;
    gap: 15px;
  }
  
  .record-content,
  .progress-content {
    grid-template-columns: 1fr;
  }
}

/* 优化移动端选择器弹窗 */
.el-select-dropdown, .el-cascader-menu, .el-date-picker__panel {
  max-height: 250px;
}

/* 级联选择器弹窗适配 */
.el-cascader-menu {
  min-width: 180px;
}

/* 按钮组样式优化 */
.el-button + .el-button {
  margin-left: 0;
}

/* 单选按钮组样式 */
.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

/* 图片上传相关样式补充 */
.image-upload-wrapper {
  width: 100%;
}
.upload-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background: rgba(255,255,255,0.9);
  padding: 20px;
  border-radius: 8px;
  z-index: 9999;
}
.image-preview-container {
  text-align: center;
}
.preview-image {
  max-width: 100%;
  max-height: 600px;
}
.image-thumbnail-list {
  margin-top: 10px;
}
.thumbnail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.thumbnail-title {
  font-size: 12px;
  color: #666;
}
.thumbnail-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.thumbnail-item {
  width: 100px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 5px;
}
.thumbnail-image {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}
.thumbnail-actions {
  display: flex;
  justify-content: center;
  gap: 5px;
  margin: 5px 0;
}
.thumbnail-info {
  font-size: 10px;
  color: #999;
  text-align: center;
}
.upload-disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>